export const CurrencyType = {
  CHF: "CHF",
  EUR: "EUR",
  USD: "USD",
} as const;

export type CurrencyType =
  | (typeof CurrencyType)[keyof typeof CurrencyType]
  | null;

export const validCurrencies: CurrencyType[] = Object.values(CurrencyType);

export const DEFAULT_PRICE_CURRENCY: NonNullable<CurrencyType> =
  CurrencyType.USD;
